import React from 'react';
import Header from '../components/Header';
import Box from '@mui/material/Box';

interface IWelcomLayoutLayout {
    children?: React.ReactNode
}

const WelcomLayout:React.FC<IWelcomLayoutLayout> = ({ children }) => {
  return (
    <Box sx={{ flexGrow: 1,
      minWidth: '494px',
      display: "flex",
      flexDirection: "column" }}>
      <Header />
      {children}
    </Box>
  );
}

export default WelcomLayout;